import React from "react";

const MAPS_URL =
  "https://www.google.com/maps/place/CASA+DI+PATSI+Stockhouse+%CE%99%CF%84%CE%B1%CE%BB%CE%B9%CE%BA%CE%AC+%CE%AD%CF%80%CE%B9%CF%80%CE%BB%CE%B1/@38.0678071,23.7552914,17z/data=!4m5!3m4!1s0x0:0xaed40861765ff4d9!8m2!3d38.0678071!4d23.7552914";

const ink = "#242321";
const bodyGray = "#56524d";
const muted = "#6f6b65";
const line = "#e5e1da";
const accent = "#ef9f12";
const eyebrow = "#9a6710";

const styles = {
  section: {
    background: "#f5f3ef",
    padding: "48px 20px 32px",
  },
  container: {
    maxWidth: 1040,
    margin: "0 auto",
  },
  brand: {
    margin: "0 0 28px",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.19em",
    textTransform: "uppercase",
    color: ink,
  },
  brandMuted: {
    color: muted,
    fontWeight: 400,
  },
  eyebrow: {
    margin: "0 0 14px",
    color: eyebrow,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.2em",
    textTransform: "uppercase",
  },
  title: {
    margin: "0 0 18px",
    color: ink,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: "clamp(36px, 6vw, 52px)",
    fontWeight: 400,
    lineHeight: 1.05,
    letterSpacing: "-0.035em",
  },
  body: {
    margin: 0,
    // maxWidth: 640,
    color: bodyGray,
    fontSize: 17,
    lineHeight: 1.65,
  },
  meta: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px 22px",
    margin: "28px 0",
    padding: "16px 0",
    borderTop: `1px solid ${line}`,
    borderBottom: `1px solid ${line}`,
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: "0.035em",
    color: ink,
  },
  metaItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: 9,
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: "50%",
    background: accent,
    flexShrink: 0,
  },
  location: {
    color: "#5c5852",
    fontSize: 15,
    lineHeight: 1.8,
  },
  locationName: {
    margin: "0 0 4px",
    color: ink,
    fontWeight: 700,
  },
  address: {
    margin: "0 0 10px",
  },
  links: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "8px 12px",
  },
  link: {
    color: "inherit",
    textDecoration: "underline",
    textUnderlineOffset: 3,
  },
  sep: {
    color: muted,
  },
};

const ExportDefault = () => {
  return (
    <section style={styles.section} aria-labelledby="bazaar-title">
      <div style={styles.container}>
        <p style={styles.brand}>
          CASA DI PATSI <span style={styles.brandMuted}>· STOCK HOUSE</span>
        </p>

        <p style={styles.eyebrow}>Bazaar · Fall Edition</p>

        <h1 id="bazaar-title" style={styles.title}>
          Bazaar Fall Edition
        </h1>

        <p style={styles.body}>
          Η Casa di Patsi παρουσιάζει το Bazaar Fall Edition στο Stock House
          Μεταμόρφωσης, με επιλεγμένα κομμάτια και προσωπική εξυπηρέτηση.
        </p>

        <div style={styles.meta} aria-label="Πληροφορίες εκδήλωσης">
          <span style={styles.metaItem}>
            <span style={styles.dot} aria-hidden="true" />
            Κυριακή 18 Οκτωβρίου 2026 · 10:00–18:00
          </span>
          <span style={styles.metaItem}>
            <span style={styles.dot} aria-hidden="true" />
            Stock House · Μεταμόρφωση
          </span>
        </div>

        <div style={styles.location}>
          <p style={styles.locationName}>Casa di Patsi Stock House</p>
          <p style={styles.address}>Ζακύνθου 2 και Οδυσσέως, Μεταμόρφωση</p>
          <div style={styles.links}>
            <a href="tel:+302102850233" style={styles.link}>
              210 285 0233
            </a>
            <span style={styles.sep}>·</span>
            <a href="mailto:info@casadipatsistock.gr" style={styles.link}>
              info@casadipatsistock.gr
            </a>
            <span style={styles.sep}>·</span>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              Δείτε την τοποθεσία
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExportDefault;
